export class EnsureModuleLoadedOnce {

  constructor(targetModule: any) {
    if(targetModule) {
      throw new Error(`${targetModule.constructor.name} has already been loaded. Import this module inside App module only.`);
    }
  }
}
